import React from "react";
import { X } from "lucide-react";
import TimeInput from "./TimeInput";

const TimeIntervalRow = ({ interval, onRemove, onChange, isDisabled, translations }) => {
    const minutesToTimeString = (minutes) => {
        if (minutes === undefined || minutes === null || minutes === '') return '';
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    };

    const timeStringToMinutes = (timeString) => {
        if (!timeString) return '';
        const [hours, minutes] = timeString.split(':').map(Number);
        return (isNaN(hours) || isNaN(minutes)) ? '' : hours * 60 + minutes;
    };

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 p-4 bg-white rounded-lg shadow-sm">
            <div className="w-full grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-4">
                <div className="w-full">
                    <label className="block text-sm text-gray-600 mb-1">
                        {translations('form.staffDistribution.startTime')}
                        <span className="text-red-500 ml-1">*</span>
                    </label>
                    <TimeInput
                        value={minutesToTimeString(interval.startTime)}
                        onChange={(value) => onChange('startTime', timeStringToMinutes(value))}
                        disabled={isDisabled}
                    />
                </div>
                
                <div className="w-full">
                    <label className="block text-sm text-gray-600 mb-1">
                        {translations('form.staffDistribution.endTime')}
                        <span className="text-red-500 ml-1">*</span>
                    </label>
                    <TimeInput
                        value={minutesToTimeString(interval.endTime)}
                        onChange={(value) => onChange('endTime', timeStringToMinutes(value))}
                        disabled={isDisabled}
                    />
                </div>

                <div className="w-full">
                    <label className="block text-sm text-gray-600 mb-1">
                        {translations('form.staffDistribution.staff')}
                        <span className="text-red-500 ml-1">*</span>
                    </label>
                    <input 
                        type="number"
                        min={0}
                        value={interval.staff}
                        onChange={(e) => onChange('staff', e.target.value)}
                        className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <button
                onClick={onRemove}
                className={`p-2 rounded-full transition-colors mt-2 sm:mt-0 self-center sm:self-start
                    ${isDisabled 
                        ? 'text-gray-300 cursor-not-allowed' 
                        : 'text-gray-400 hover:text-red-500 hover:bg-red-50'
                    }`}
                title={translations('form.staffDistribution.removeInterval') || "Remove Interval"}
                disabled={isDisabled}
            >
                <X size={20} />
            </button>
        </div>
    );
}

export default TimeIntervalRow;